<template>
  <BaseDataIterator :service="fetchProjects">
    <template #default="dataIteratorProps">
      <div key="grid_view" class="p-4 bg-gray-100">
        <BaseGrid :columns="4" class="gap-4">
          <ProjectListItem v-for="item in dataIteratorProps.data" :key="item.id" :project="item" />
        </BaseGrid>
      </div>
    </template>
  </BaseDataIterator>
</template>

<script>
import { accountProjectsClient } from '@/api/clients';
import ProjectListItem from './ProjectListItem.vue';

export default {
  components: {
    ProjectListItem,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    since: {
      type: String,
      default: '',
    },
    until: {
      type: String,
      default: '',
    },
  },
  methods: {
    fetchProjects(params) {
      return accountProjectsClient.list(this.accountId, {
        ...params,
        filter: {
          ...(params?.filter || {}),
          product_category_is: 'tactics',
          ...(this.since && this.until
            ? { created_between: [this.since, this.until].join(',') }
            : {}),
        },
        page_size: 20,
      });
    },
  },
};
</script>
